import { AuthenticatedLayout } from "../../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import { FC } from "react";
import { UndoMergeResource } from "../../../components/Resource/UndoMergeResource";
import { useParams } from "react-router-dom";

export interface IUndoMergeResourcesPage {}
export const UndoMergeResourcesPage: FC<IUndoMergeResourcesPage> = () => {
  const { resourceName } = useParams();
  
  return (
    <AuthenticatedLayout
      pageTitle={`Undo Merge ${resourceName}`}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: `${resourceName}`, navigateTo: `/resources/${resourceName}` },
        {
          text: `Undo Merge ${resourceName}`,
          navigateTo: `/resources/${resourceName}/undo-merge`,
        },
      ]}
      mainContents={<UndoMergeResource />}
    />
  );
};
